import PropTypes from 'prop-types';
import React from 'react';
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import accounting from 'accounting';
import { getCurrencySymbol } from 'components/modules/master/formatters';

export default class AccessorialRatesWeightBaseEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { accessorialRate: this.props.accessorialRate || {} };
  }

  handleFreeWeightChange() {
    return (e) => {
      const freeWeight = e.target.value;
      this.onChange('free', freeWeight);
    };
  }

  handleMinimumRateChange() {
    return (e) => {
      const minimumRate = e.target.value;
      this.onChange('minimum_rate', minimumRate);
    };
  }

  handleMaximumRateChange() {
    return (e) => {
      const maximumRate = e.target.value;
      this.onChange('maximum_rate', maximumRate);
    };
  }

  handleRateChange() {
    return (e) => {
      const rate = e.target.value;
      this.onChange('rate', rate);
    };
  }

  onChange(key, value) {
    const accessorialRate = this.state.accessorialRate;
    accessorialRate[key] = Number(value);
    let description = `${accounting.formatMoney(
      accessorialRate.rate,
      getCurrencySymbol(DEFAULT_CURRENCY),
    )} per lb. `;
    description +=
      accessorialRate.free && accessorialRate.free > 0
        ? `First ${accessorialRate.free} lbs for free. `
        : '';
    description +=
      accessorialRate.minimum_rate && accessorialRate.minimum_rate > 0
        ? `With ${accounting.formatMoney(
            accessorialRate.minimum_rate,
            getCurrencySymbol(DEFAULT_CURRENCY),
          )} minimum, `
        : '';
    description +=
      accessorialRate.maximum_rate && accessorialRate.maximum_rate > 0
        ? `and ${accounting.formatMoney(
            accessorialRate.maximum_rate,
            getCurrencySymbol(DEFAULT_CURRENCY),
          )} maximum. `
        : '';
    accessorialRate.description = description;
    this.setState({ accessorialRate: accessorialRate });

    this.props.onChange(accessorialRate);
  }

  validateRate(rate) {
    if (rate > 0) {
      return '';
    }
    return 'error';
  }

  validateFree(free) {
    if (free >= 0) {
      return '';
    }
    return 'error';
  }

  validateMinMax() {
    const minimumRate = this.state.accessorialRate.minimum_rate;
    const maximumRate = this.state.accessorialRate.maximum_rate;
    if (minimumRate >= 0 && maximumRate >= minimumRate) {
      return '';
    }
    return 'error';
  }

  render() {
    const accessorialRate = this.state.accessorialRate;
    const disablefreeWeight =
      (accessorialRate.minimum_rate && accessorialRate.minimum_rate !== 0) ||
      (accessorialRate.maximum_rate && accessorialRate.maximum_rate !== 0);
    const disMinimumAndMaximum =
      accessorialRate.free && accessorialRate.free !== 0;
    return (
      <Grid fluid>
        <Row className="show-grid">
          <Col xs={2}>
            <FormGroup>
              <ControlLabel>{accessorialRate.name}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.rate}
                onChange={this.handleRateChange()}
                bsStyle={this.validateRate(accessorialRate.rate)}
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>Free Weight, lbs</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.free}
                onChange={this.handleFreeWeightChange()}
                bsStyle={this.validateFree(accessorialRate.free)}
                disabled={disablefreeWeight}
              />
            </FormGroup>
          </Col>
          <Col xs={2}>
            <FormGroup>
              <ControlLabel>{`Minimum Rate, ${getCurrencySymbol(
                DEFAULT_CURRENCY,
              )}`}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.minimum_rate}
                onChange={this.handleMinimumRateChange()}
                bsStyle={this.validateMinMax()}
                disabled={disMinimumAndMaximum}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>{`Maximum Rate, ${getCurrencySymbol(
                DEFAULT_CURRENCY,
              )}`}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.maximum_rate}
                onChange={this.handleMaximumRateChange()}
                bsStyle={this.validateMinMax()}
                disabled={disMinimumAndMaximum}
              />
            </FormGroup>
          </Col>
        </Row>
      </Grid>
    );
  }
}

AccessorialRatesWeightBaseEditor.propTypes = {
  accessorialRate: PropTypes.object,
  onChange: PropTypes.func,
};
